import styles from 'components/cases/common/CasesFirstViewWhite/CasesFirstViewWhite.module.scss'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import Breadcrumb from 'components/commons/Breadcrumb/Breadcrumb'
import CaseFirstViewItemWhite from '../CaseFirstViewItemWhite'

const tweenVars: gsap.TimelineVars = [
  {
    y: '50',
    duration: 1,
    opacity: 0,
    ease: Power4.easeOut,
  },
]

export type firstViewItemWhite = {
  breadcrumb: string
  title1: string
  subtitle?: string
  introduction_text: string | JSX.Element
  company: string
  tag1text?: string
  tag1src?: string
  tag2text?: string
  tag2src?: string
  tag3text?: string
  tag3src?: string
  linkText?: string
  linkUrl?: string
  image?: string
  alt?: string
  industryTagText?: string
  industryTagSrc?: string
}

type Props = {
  firstViewItemWhite: firstViewItemWhite
}

const CasesFirstViewWhite: React.FC<Props> = ({ firstViewItemWhite }) => {
  const timeline = gsap.timeline()

  const wrapper = useRef<HTMLDivElement | null>(null)
  const title = useRef<HTMLDivElement | null>(null)
  const introduction = useRef<HTMLParagraphElement | null>(null)
  const sub_text = useRef<HTMLDivElement | null>(null)
  const image = useRef<HTMLImageElement | null>(null)
  const tag = useRef<HTMLUListElement | null>(null)

  const paths = [
    { name: 'TOP', url: '/' },
    { name: 'Case study', url: '/cases' },
    { name: firstViewItemWhite.breadcrumb, url: '#' },
  ]

  useEffect(() => {
    if (!wrapper.current) return;

    timeline.set(wrapper.current, { opacity: 1 });
    wrapper.current.style.opacity = "1";

    timeline
      .from(title.current, tweenVars[0], 0.5)
      .from(introduction.current, tweenVars[0], 0.8)
      .from(sub_text.current, tweenVars[0], 1.1)
      .from(tag.current, tweenVars[0], 1.4)
      .from(image.current, tweenVars[0], 1.7);
  }, []);

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.fv}>
        <div className={styles.fv_left}>
          <div className={styles.breadcrumbs}>
            <Breadcrumb paths={paths} />
          </div>
          <CaseFirstViewItemWhite
            subtitle={firstViewItemWhite.subtitle}
            title1={firstViewItemWhite.title1}
            company={firstViewItemWhite.company}
            introduction_text={firstViewItemWhite.introduction_text}
            tag1text={firstViewItemWhite.tag1text}
            tag1src={firstViewItemWhite.tag1src}
            tag2text={firstViewItemWhite.tag2text}
            tag2src={firstViewItemWhite.tag2src}
            tag3text={firstViewItemWhite.tag3text}
            tag3src={firstViewItemWhite.tag3src}
            linkText={firstViewItemWhite.linkText}
            linkUrl={firstViewItemWhite.linkUrl}
            industryTagText={firstViewItemWhite.industryTagText}
            industryTagSrc={firstViewItemWhite.industryTagSrc}
          />
        </div>
        <div className={styles.fv_img}>
          <figure className={styles.fv_img_mv}>
            <img
              src={firstViewItemWhite.image}
              alt={firstViewItemWhite.alt}
              ref={image}
              className={styles.fv_img_mv_img}
            />
          </figure>
        </div>
      </div>
    </section>
  )
}

export default CasesFirstViewWhite
